@if (operand) {
  @switch (operand.type) {
    @case ('static_value') {
      "{{ operand.value }}"
    }
    @default {
      {{ operand.value }}
    }
  }
}
